/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface BorrowerDocumentDto
 */
export interface BorrowerDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof BorrowerDocumentDto
     */
    step: number;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof BorrowerDocumentDto
     */
    replaceFileType?: FileTypeEnum;
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof BorrowerDocumentDto
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDocumentDto
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDocumentDto
     */
    fileName?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerDocumentDto
     */
    storedFileId?: string;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerDocumentDto
     */
    signatureDate?: Date;
}



/**
 * Check if a given object implements the BorrowerDocumentDto interface.
 */
export function instanceOfBorrowerDocumentDto(value: object): value is BorrowerDocumentDto {
    if (!('step' in value) || value['step'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function BorrowerDocumentDtoFromJSON(json: any): BorrowerDocumentDto {
    return BorrowerDocumentDtoFromJSONTyped(json, false);
}

export function BorrowerDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'step': json['step'],
        'replaceFileType': json['replaceFileType'] == null ? undefined : FileTypeEnumFromJSON(json['replaceFileType']),
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'label': json['label'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'signatureDate': json['signatureDate'] == null ? undefined : (new Date(json['signatureDate'])),
    };
}

export function BorrowerDocumentDtoToJSON(json: any): BorrowerDocumentDto {
    return BorrowerDocumentDtoToJSONTyped(json, false);
}

export function BorrowerDocumentDtoToJSONTyped(value?: BorrowerDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'step': value['step'],
        'replaceFileType': FileTypeEnumToJSON(value['replaceFileType']),
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'label': value['label'],
        'fileName': value['fileName'],
        'storedFileId': value['storedFileId'],
        'signatureDate': value['signatureDate'] == null ? undefined : ((value['signatureDate']).toISOString()),
    };
}

